import { wrapProperty } from "@nuxtjs/composition-api";

/**
 * This is a temporary file that was created to start our journey into
 * converting the codebase to a composition structure.
 */

export * from "./carts";
export * from "./categories";
export * from "./images";
export * from "./likes";
export * from "./ltks";
export * from "./product-details";
export * from "./product-sets";
export * from "./products";
export * from "./retailer-products";
export * from "./translations";
export * from "./utils";
export * from "./wishlists";
export * from "./axios";
export * from "./settings";
export * from "./experiments";

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useAmplitude
 * @desc     A simple composable that merely wraps the $amplitude plugin into a
 *           simple composable accessor. Will need further development and a possible
 *           rewrite of the amplitude plugin.
 *
 * @summary  Composable used to access Amplitude plugin
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useAmplitude = wrapProperty("$amplitude", false);

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useSnowplow
 * @desc     A simple composable that merely wraps the $snowplow plugin into a
 *           simple composable accessor.
 *
 * @summary  Composable used to access Snowplow plugin
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useSnowplow = wrapProperty("$snowplow", false);

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useAuth
 * @desc     A simple composable that merely wraps the $auth plugin into a
 *           simple composable accessor. This may have a native composable in the
 *           future. might remove.
 *
 * @summary  Composable used to access Auth plugin
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useAuth = wrapProperty("$auth", false);

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useConfig
 * @desc     A simple composable that merely wraps the $config plugin into a
 *           simple composable accessor. Might remove for better config approach
 *           with the composables API.
 *
 * @summary  Composable used to access the nuxt run time config through a plugin
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useConfig = wrapProperty("$config", false);

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useVuetify
 * @desc     A simple composable that merely wraps the $vuetify plugin into a
 *           simple composable accessor. This may have a native composable in the
 *           future. might remove.
 *
 * @summary  Composable used to access Vuetify plugin
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useVuetify = wrapProperty("$vuetify", false);

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useMetaService
 * @desc     A simple composable that merely wraps the $metaService plugin into a
 *           simple composable accessor. This may have a native composable in the
 *           future. might remove.
 *
 * @summary  Composable used to access MetaService plugin
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useMetaService = wrapProperty("$metaService", false);

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useLinkService
 * @desc     A simple composable that merely wraps the $linkService plugin into a
 *           simple composable accessor. This may have a native composable in the
 *           future. might remove.
 *
 * @summary  Composable used to access LinkService plugin
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useLinkService = wrapProperty("$linkService", false);

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useBranchService
 * @desc     A simple composable that merely wraps the $branch plugin into a
 *           simple composable accessor. This may have a native composable in the
 *           future. might remove.
 *
 * @summary  Composable used to access BranchService plugin
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useBranchService = wrapProperty("$branch", false);

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useFeatureDetection
 * @desc     A simple composable that merely wraps the $featureDetection plugin into a
 *           simple composable accessor. This may have a native composable in the
 *           future. might remove.
 *
 * @summary  Composable used to access FeatureDetectionfeatureDetection plugin
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useFeatureDetection = wrapProperty("$featureDetection", false);

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useGtm
 * @desc     A simple composable that merely wraps the $gtm plugin into a
 *           simple composable accessor. 
 *
 * @summary  Composable used to access GTM plugin
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useGtm = wrapProperty("$gtm", false);
